import React from 'react';

export function Container(props: React.PropsWithChildren<{}>) {
  return (
    <div className="bg-white shadow-lg p-8 w-90 max-w-md container-frame">
      {props.children}
    </div>
  );
}
